"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { getImageURL, useSwiperSliderOptions, sanitizeHTML } from "@/lib";
import { Navigation } from "swiper/modules";

export const HomePageTestimonialSection = ({
    data = {},
    slug = "certification",
}) => {
    const { testimonial_slider = [], heading } = data;

    const {
        nextSlide,
        prevSlide,
        sliderButtons: { hasNext, hasPrev },
        options: imagesSliderOptions,
    } = useSwiperSliderOptions({
        modules: [Navigation],
        clickable: "true",
        slidesPerView: 1,
        spaceBetween: 30,
        grabCursor: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            600: {
                slidesPerView: 1,
            },
            992: {
                slidesPerView: 1,
            },
            1200: {
                slidesPerView: 1,
            },
        },
    });

    return (
        <>
            <section className="testimonial__ind_section">
                <div className="custom-container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-9">
                            <div className="section_header text-center">
                                <h2
                                    className="heading fs-48 fw-300"
                                    dangerouslySetInnerHTML={{
                                        __html: sanitizeHTML(heading),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="testimonial__wrapper">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-12 col-lg-10 col-xl-10">
                                <div className="testimonial__ind_wrapper">
                                    <Swiper
                                        {...imagesSliderOptions}
                                        className="testimonial__ind_slider"
                                    >
                                        {Array.isArray(testimonial_slider) &&
                                            testimonial_slider.map(
                                                (item, idx) => (
                                                    <SwiperSlide key={idx}>
                                                        <div className="item__wrap">
                                                            <div className="row item__row align-items-center">
                                                                <div className="col-12 col-md-3 col-lg-3 col-xl-2 item__col">
                                                                    <div className="img__block">
                                                                        <div className="bg__shape" />
                                                                        <div className="img__wrap">
                                                                            <img
                                                                                className="img-fluid"
                                                                                src={
                                                                                    item
                                                                                        ?.image
                                                                                        ?.src
                                                                                        ? getImageURL(
                                                                                              item
                                                                                                  .image
                                                                                                  .src
                                                                                          )
                                                                                        : ""
                                                                                }
                                                                                alt={
                                                                                    item
                                                                                        ?.image
                                                                                        ?.alt ||
                                                                                    item?.name ||
                                                                                    ""
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-9 col-lg-9 col-xl-10 item__col">
                                                                    <div className="single__item">
                                                                        <div className="content__wrap">
                                                                            <div
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: sanitizeHTML(
                                                                                        item?.description || ""
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="person__wrap">
                                                                            <div className="person__name fs-28 fw-600">
                                                                                <span
                                                                                    className="text-gradient"
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: sanitizeHTML(item?.name),
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div
                                                                                className="person__company fs-18 fw-500"
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: sanitizeHTML(item?.designation),
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="quote-icon">
                                                                            <img
                                                                                className="img-fluid"
                                                                                src={getImageURL(
                                                                                    "/upload/media/quote_icon_1757406045.webp"
                                                                                )}
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                )
                                            )}
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <ul className="t__slider_btn list-unstyled justify-content-center">
                                    <li
                                        className={
                                            "prev-btn-tsitem" +
                                            (!hasPrev
                                                ? " swiper-button-disabled"
                                                : "")
                                        }
                                    >
                                        <a
                                            href="#!"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                prevSlide();
                                            }}
                                            style={{
                                                ...(!hasPrev && {
                                                    filter: "saturate(0)",
                                                    opacity: 0.5,
                                                }),
                                            }}
                                        >
                                            <svg
                                                width={55}
                                                height={55}
                                                viewBox="0 0 55 55"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect
                                                    x="-0.793269"
                                                    y="0.793269"
                                                    width="49.976"
                                                    height="49.1827"
                                                    rx="24.5913"
                                                    transform="matrix(-1 0 0 1 52.1049 2.53857)"
                                                    stroke="#0DB02B"
                                                    strokeWidth="1.58654"
                                                />
                                                <path
                                                    d="M43.3789 27.923C43.817 27.923 44.1722 28.2782 44.1722 28.7163C44.1722 29.1544 43.817 29.5096 43.3789 29.5096V28.7163V27.923ZM11.8703 29.2772C11.5605 28.9674 11.5605 28.4652 11.8703 28.1554L16.9186 23.107C17.2284 22.7973 17.7307 22.7973 18.0405 23.107C18.3503 23.4168 18.3503 23.9191 18.0405 24.2289L13.5531 28.7163L18.0405 33.2037C18.3503 33.5135 18.3503 34.0158 18.0405 34.3256C17.7307 34.6354 17.2284 34.6354 16.9186 34.3256L11.8703 29.2772ZM43.3789 28.7163V29.5096H12.4312V28.7163V27.923H43.3789V28.7163Z"
                                                    fill="#0DB02B"
                                                />
                                            </svg>
                                        </a>
                                    </li>
                                    <li
                                        className={
                                            "next-btn-tsitem" +
                                            (!hasNext
                                                ? " swiper-button-disabled"
                                                : "")
                                        }
                                    >
                                        <a
                                            href="#!"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                nextSlide();
                                            }}
                                            style={{
                                                ...(!hasNext && {
                                                    filter: "saturate(0)",
                                                    opacity: 0.5,
                                                }),
                                            }}
                                        >
                                            <svg
                                                width={55}
                                                height={55}
                                                viewBox="0 0 55 55"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect
                                                    x="3.1546"
                                                    y="3.33184"
                                                    width="49.976"
                                                    height="49.1827"
                                                    rx="24.5913"
                                                    stroke="#0DB02B"
                                                    strokeWidth="1.58654"
                                                />
                                                <path
                                                    d="M12.6738 27.923C12.2357 27.923 11.8806 28.2782 11.8806 28.7163C11.8806 29.1544 12.2357 29.5096 12.6738 29.5096V28.7163V27.923ZM44.1824 29.2772C44.4922 28.9674 44.4922 28.4652 44.1824 28.1554L39.1341 23.107C38.8243 22.7973 38.322 22.7973 38.0122 23.107C37.7024 23.4168 37.7024 23.9191 38.0122 24.2289L42.4996 28.7163L38.0122 33.2037C37.7024 33.5135 37.7024 34.0158 38.0122 34.3256C38.322 34.6354 38.8243 34.6354 39.1341 34.3256L44.1824 29.2772ZM12.6738 28.7163V29.5096H43.6215V28.7163V27.923H12.6738V28.7163Z"
                                                    fill="#0DB02B"
                                                />
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
